import {observer} from 'mobx-react';
import React, {useCallback, useEffect} from 'react';
import theme from './theme.module.scss';
import {Table} from '@vidazoo/ui-kit';
import DiffTableChartRow from './components/DiffTableChartRow';
import {ChartEditModel} from '../../../modules/charts/item/edit/model/ChartEditModel.mdl';
import DiffTableChartHeader from './components/DiffTableChartHeader';
import {ChartCreateModel} from '../../../modules/charts/item/create/model/ChartCreateModel.mdl';

const ROW_HEIGHT = 45;
const LOADING_ROW_HEIGHT = 24;
const LOADING_ITEMS_COUNT = () => Math.round(window.innerHeight / LOADING_ROW_HEIGHT);

export interface IDiffTableChartProps {
    report: any;
    appearance?: 'default' | 'classic';
    listClassName?: any;
    columnsWidth?: {
        [index: string]: number;
    };
    setColumnsWidth?: (columnsWidth: { [index: string]: number }) => void;
    model: ChartEditModel | ChartCreateModel;
}

function DiffTableChart(props: IDiffTableChartProps): React.JSX.Element {

    const {model, appearance} = props;
    const classic = appearance === 'classic';
    useEffect(() => {
        if (classic && !model.freeze && model.tableColumns[0]) model.setFreeze(model.tableColumns[0], true);
    }, [classic, model, model.tableColumns]);

    const renderTableRow = useCallback((itemIndex: number, viewportIndex: number, style: React.CSSProperties) => {
        return (
            <DiffTableChartRow
                key={itemIndex}
                itemIndex={itemIndex}
                viewportIndex={viewportIndex}
                model={model}
                appearance={appearance}
                style={style}/>
        );
    }, [model.maskItems, model.columns, model, appearance]);

    const renderTableHeader = useCallback(() => {
        return (
            <DiffTableChartHeader model={model} appearance={appearance}/>
        );
    }, [model, appearance]);

    return (
        <Table
            className={`${theme.diffTable} ${classic ? theme.classic : ''}`}
            itemsCount={(model.isLoading && !model.data) ? LOADING_ITEMS_COUNT() : model.maskItems.length}
            rowHeight={classic ? 60 : ROW_HEIGHT}
            renderRow={renderTableRow}
            renderHeader={renderTableHeader}
            columnsManager={model}
            overscanItems={5}
            useStickyScrollbar={classic}
        />
    );
}

export default observer(DiffTableChart);
